export default __webpack_public_path__ + "static/media/ring.7044cea9.webp";